import { buffsData } from '../data/regionalChef/buffsData';

// เพิ่มลอจิก: รับค่า Modifier ประจำด่านเข้ามาคำนวณด้วย
export const calculateCombineAP = (baseAp, actionId, activeBuffIds, currentModifier) => {
  let finalAp = baseAp;
  const context = { actionId }; 

  // เช็กอุปกรณ์ลด AP
  activeBuffIds.forEach(buffId => {
    const buff = buffsData[buffId];
    if (buff && buff.type === 'ap_discount' && buff.condition(context)) {
      finalAp = buff.effect(finalAp);
    }
  });

  // เช็กเงื่อนไขประจำด่าน (Stage Modifier)
  // เช่น ถ้าสุ่มเจอ "พ.ร.บ. ป่าไม้ ร.๕" (ฟืนหายาก) แอ็กชันไฟจะเสีย AP เพิ่ม
  if (currentModifier?.id === 'forestry_law' && (actionId === 'action_boil' || actionId === 'action_stir_fry')) {
    finalAp += 1;
  }

  return finalAp;
};

export const calculateServePrice = (basePrice, recipeInfo, activeBuffIds, recipeLevel = 1, currentModifier) => {
  // คำนวณ Base Price ใหม่ตามเลเวล (เลเวลละ +15 บาท)
  let finalPrice = basePrice + ((recipeLevel - 1) * 15);
  const context = { primaryAction: recipeInfo.primaryAction, id: recipeInfo.id };

  activeBuffIds.forEach(buffId => {
    const buff = buffsData[buffId];
    if (buff && buff.condition(context)) {
      if (buff.type === 'price_multiplier' || buff.type === 'price_adder') {
         finalPrice = buff.effect(finalPrice);
      }
    }
  });

  // เช็กเงื่อนไขประจำด่าน
  // เช่น ถ้าสุ่มเจอ "เทศกาลกินเจ" เมนูหมูไก่ราคาจะตก
  if (currentModifier?.id === 'vegetarian_fest' && (context.id.includes('pork') || context.id.includes('chicken'))) {
    finalPrice = Math.floor(finalPrice * 0.5); 
  }

  return Math.floor(finalPrice);
};